import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageSwitch from '../LanguageSwitch'
import logo from '../../../assets/logo.png'

const officialHomeUrl = 'https://www.hhlinen.com/'
const officialContactUrl = 'https://www.hhlinen.com/contact-us/'
const officialNavLinkClass =
  'font-official-nav inline-flex h-[40px] items-center whitespace-nowrap text-[13px] font-medium uppercase tracking-[0.01em] text-white/[0.76] transition-colors duration-200 hover:text-white'

function Navbar() {
  const { t } = useTranslation()
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const updateScrollState = () => {
      setIsScrolled(window.scrollY > 12)
    }

    updateScrollState()
    window.addEventListener('scroll', updateScrollState, { passive: true })

    return () => window.removeEventListener('scroll', updateScrollState)
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#393939]'
          : 'bg-[linear-gradient(180deg,#000_0%,rgba(0,0,0,0)_100%)]'
      }`}
    >
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-white/8" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 z-10 hidden -translate-x-1/2 -translate-y-1/2 items-center justify-center lg:flex">
        <span className="font-header-nav relative whitespace-nowrap text-[25px] leading-none tracking-[0.14em] text-white">
          {t('nav.aiExperienceCenter')}
          <span className="absolute -bottom-2 left-1/2 h-px w-[72%] -translate-x-1/2 bg-white/62" />
        </span>
      </div>
      <div className="mx-auto grid min-h-[84px] max-w-[1440px] grid-cols-[auto_1fr_auto] items-center gap-4 px-4 md:px-6 lg:px-8">
        <Link to="/upload" className="flex w-[128px] shrink-0 items-center md:w-[138px]" aria-label="Forecast Spring">
          <img src={logo} alt="Forecast Spring" className="h-[70px] w-auto object-contain md:h-[78px]" />
        </Link>

        <nav className="hidden min-w-0 items-center gap-8 xl:flex">
          <a
            href={officialHomeUrl}
            target="_blank"
            rel="noreferrer"
            className={officialNavLinkClass}
          >
            {t('nav.home')}
          </a>
          <a
            href={officialContactUrl}
            target="_blank"
            rel="noreferrer"
            className={officialNavLinkClass}
          >
            {t('nav.contactUs')}
          </a>
        </nav>

        <div className="flex items-center justify-end gap-4 md:gap-5">
          <LanguageSwitch />
        </div>
      </div>
    </header>
  )
}

export default Navbar
